module.exports = __webpack_public_path__ + "img/ee-icon.2ab6f9b1.svg";